import {
  POST_ADMIN_USER_LOGIN,
  POST_ADMIN_USER_LOGIN_SUCCESS,
  POST_ADMIN_USER_LOGIN_ERROR
} from "./actionTypes"

const initialState = {
  error: null,
  user_login: [],
  loading: false
}

const AdminUserLogin = (state = initialState, action) => {
  switch (action.type) {
    case POST_ADMIN_USER_LOGIN:
      return {
        ...state,
        loading: true
      }

    case POST_ADMIN_USER_LOGIN_SUCCESS:
      return {
        ...state,
        user_login: action.payload,
        loading: false
      }

    case POST_ADMIN_USER_LOGIN_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    default:
      return state
  }
}

export default AdminUserLogin;
